import React from 'react'
import styles from "./Templatepage.module.css"
import { Link } from 'react-router-dom'


//page displaying template categories(GnHero,categories)
const Templatepage1 = ({ categories }) => {
    return (
        <>
            <section className={styles.hero}>
                <div className={styles.container}>
                    <div className={styles.hero_content}>
                        <h1>Premium Template Categories</h1>
                        <p>Discover our carefully curated collection of professional templates designed to accelerate your development process.</p>
                    </div>
                </div>
            </section>

            <section className={styles.categories}>
                <div className={styles.container}>
                    <div className={styles.categories_grid}>
                        {Object.entries(categories).map(([key, value]) => (
                            <Link to={`/templates/${key}`} className={styles.category_card} onClick="location.href='category-templates.html?category=dashboard'">
                                <div className={styles.category_icon}>📊</div>
                                <h3>{value.title}</h3>
                                <p>{value.desc}</p>
                                <div className={styles.category_stats}>
                                    {/* <span className={styles.template_count}>{`${value.list.length} ${value.list.length === 1 ? "Template" : "Templates"}`}</span> */}
                                    {/* <span className={styles.popularity}>⭐ Popular</span> */}
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </>


    )
}

export default Templatepage1